/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import {
  PreparationStepInput,
  RecipeImageInput,
  EquipmentInput,
  PreparationStepGroupInput,
  IngredientInput,
  RecipeUpdateInput,
  RecipeCreateInput,
  IngredientGroupInput
} from "@/types";

export function mapFormToRecipeRequestDto(formData: any): RecipeCreateInput|RecipeUpdateInput {
  const data: any = {
    name: formData.name,
    description: formData.description,
    authorId: null,
    forHowManyPersonCode: formData.for_how_many_person,
    timeConsumingCode: formData.time_consuming,
    sourceRecipeUrl: formData.source_recipe_url,
    image: mapImageToDto(formData.image),
    stepGroups: formData.stepGroups as PreparationStepGroupInput[],
    steps: mapStepsToDto(formData.steps),
    ingredientGroups: formData.groups as IngredientGroupInput[],
    ingredients: mapIngredientsToDto(formData.ingredients),
    appliances: mapAppliancesToDto(formData.appliances),
    mealTypeIds: formData.mealTypes && formData.mealTypes.length > 0
      ? formData.mealTypes.map((mealType: any) => mealType.value as number)
      : []
  };

  if (formData.id) {
    data.id = formData.id;
    return data as RecipeUpdateInput;
  }

  return data as RecipeCreateInput;

}

function mapAppliancesToDto(appliances: any[]): EquipmentInput[] | null {
  if (!appliances || appliances.length === 0) {
    return null;
  }

  return appliances.map((appliance: any) => {
    let applianceData: EquipmentInput;

    if (appliance?.selected?.addedOption) {
      applianceData = {
        id: null,
        name: appliance?.selected?.label as string
      }
    } else {
      applianceData = {
        id: appliance?.selected?.value as number,
        name: null
      }
    }

    return applianceData;
  });
}

function mapIngredientsToDto(ingredients: any[]): IngredientInput[] {
  return ingredients.map((ingredient: any) => {
    const ingredientData: IngredientInput = {
      group: ingredient.group as string,
      quantity: String(ingredient.quantity)
    } as IngredientInput;

    if (ingredient?.selected?.addedOption) {
      ingredientData.name = ingredient?.selected?.label as string;
    } else {
      ingredientData.id = ingredient?.selected?.value as number;
    }

    return ingredientData;
  });
}

function mapImagesToDto(images: any[]): RecipeImageInput[] | null {
  if (!images || images.length === 0) {
    return null;
  }

  return images.map((img: any) => mapImageToDto(img)) as RecipeImageInput[];
}

function mapImageToDto(image: any): RecipeImageInput | null {
  if (!image) {
    return null;
  }

  return {
    id: image.id ?? null,
    filename: image.filename as string,
    url: image.url as string
  } as RecipeImageInput;
}

function mapStepsToDto(steps: any[]): PreparationStepInput[] {
  return steps.map((step: any) => ({
    key: String(step.key),
    id: step.id ?? null,
    group: step.group as string,
    description: step.description as string,
    images: mapImagesToDto(step.images)
  })) as PreparationStepInput[];
}

